import { Config } from 'dompurify';

export const CONFIG_SANITIZE_STYLE = {
	/**
	 * Явно опасные CSS-свойства, использовавшиеся для XSS, исполнения скриптов
	 * или загрузки внешних ресурсов в старых браузерах.
	 *
	 * Проверяются по имени свойства (`decl.prop`), без учёта регистра.
	 */
	FORBIDDEN_PROPERTIES: [
		/** Firefox/Gecko XBL — мог загружать XML с JS-кодом */
		/^(-moz-binding)$/i,
		/** Internet Explorer behaviors — подключали HTC-файлы (HTML Components) */
		/^(behavior|-ms-behavior)$/i,
		/**  IE-фильтры: могли содержать `progid:DXImageTransform.Microsoft...` */
		/^(filter|-ms-filter)$/i,
		/** Старые Opera (Presto): могли триггерить переходы и события */
		/^(?:-o-link|-o-link-source)$/i
	],
	/**
	 * Регулярные выражения для поиска заведомо опасных конструкций
	 * внутри значений CSS-свойств (decl.value).
	 *
	 * Эти конструкции потенциально позволяют выполнить JS-код,
	 * загрузить внешние ресурсы, обойти CSP или использовать уязвимости
	 * старых движков (IE, Gecko).
	 *
	 * Проверка идёт на уровне значений (например: "background: javascript:...").
	 */
	FORBIDDEN_VALUES: [
		/** CSS expressions — старые IE (до v8) */
		/expression\s*\(/i,
		/** Импорт внешних стилей прямо из значения */
		/@import/i,
		/** Firefox XBL bindings внутри значений (редкий, но опасный кейс) */
		/-moz-binding/i,
		/** JavaScript URL — типичный XSS-вектор */
		/javascript:/i,
		/** VBScript URL — уязвимость старых IE */
		/vbscript:/i
	],
	/**
	 * Регулярное выражение для проверки допустимых URL в style.
	 * Разрешает только http/https-ссылки и относительные пути (/images/background.png).
	 */
	SAFE_URL: /^(https?:\/\/|\/(?!\/))/i,
	/** Разрешаем data: только как image с безопасными типами: png, jpeg, jpg, gif, webp */
	SAFE_DATA_IMAGE: /^\s*data:image\/(?:png|jpe?g|gif|webp)(?:;charset=[^;,]+)?;base64,/i,
	/** Разрешенные значения @-правил */
	ALLOW_AT_RULES: ['media', 'keyframes'],
	/** Явно небезопасные  значения @-правил */
	FORBIDDEN_AT_RULES: ['import', 'font-face', 'namespace']
};

export const DEFAULT_CONFIG_SANITIZE_HTML: Config = {
	/** Встроенная настройка основных безопасных тегов и атрибутов, список можно посмотреть:
	 * {@link https://github.com/cure53/DOMPurify/blob/main/src/tags.ts}
	 * {@link https://github.com/cure53/DOMPurify/blob/main/src/attrs.ts}
	 */
	USE_PROFILES: { html: true, svg: true },
	/** Добавляет дополнительные атрибуты, которых нет в настройке USE_PROFILES */
	ADD_ATTR: ['href', 'target', 'rel'],
	/** Строго запрещает конкретные теги */
	FORBID_TAGS: ['script', 'object', 'embed', 'iframe', 'form', 'input'],
	/** Строго запрещает конкретные атрибуты */
	FORBID_ATTR: ['onclick', 'onerror', 'onload']
};
